import calls from '@/backend/api-calls'

const state = () => ({
  documentTypes: [],
  selected: [],
  allSelected: false,
  loading: false,
  pagination: {
    page: 1,
    pages: 1
  }
})

// getters
const getters = {
  ids: state => {
    return state.documentTypes.map(d => d.id);
  }
}

// actions
const actions = {
  getDocumentTypes: ({commit}, parameters) => {
    commit("setLoading", true);

    return new Promise((resolve, reject) => {
      calls.rfqDocumentTypes.get(parameters)
        .then(resp => {
          commit("setDocumentTypes", resp.data);
          commit("setLoading", false);
          resolve(resp);
        }).catch(err => {
          commit("setLoading", false);
          reject(err);
        })
    })
  },
  addDocumentType({commit}, data) {
    return new Promise((resolve, reject) => {
      calls.rfqDocumentTypes.post(data)
        .then(resp => {
          commit("insertDocumentType", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Rfq document type successfully added'
          }, { root: true });

          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  updateDocumentType: ({commit}, { documentTypeId, data }) => {
    return new Promise((resolve, reject) => {
      calls.rfqDocumentType.put(documentTypeId, data).then(
        resp => {
          commit("insertUpdatedDocumentType", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Rfq document type successfully updated'
          }, { root: true });

          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  deleteDocumentType: ({commit}, documentTypeId) => {
    return new Promise((resolve, reject) => {
      calls.rfqDocumentType.delete(documentTypeId).then(
        resp => {
          commit("removeDocumentType", documentTypeId);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Rfq document type successfully deleted'
          }, { root: true });

          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  toggleAllSelected: ({commit, getters}, value) => {
    if (value) {
      commit("selectAll", getters.ids);
    } else {
      commit("deselectAll");
    }
  }
}

// mutations
const mutations = {
  setLoading(state, status) {
    state.loading = status;
  },
  setDocumentTypes(state, data) {
    state.pagination = data.pagination;
    state.documentTypes = data.results;
  },
  insertDocumentType(state, data) {
    state.documentTypes.push(data);
  },
  insertUpdatedDocumentType(state, data) {
    state.documentTypes.forEach((documentType, i) => {
      if (documentType.id == data.id) {
        state.documentTypes.splice(i, 1, data);
      }
    })
  },
  removeDocumentType(state, documentTypeId) {
    state.documentTypes.forEach((documentType, i) => {
      if (documentType.id == documentTypeId) {
        state.documentTypes.splice(i, 1);
      }
      const index = state.selected.indexOf(documentTypeId);
      if (index != -1) {
        state.selected.splice(index, 1);
      }
    })
  },
  setFilter(state, { field, value }) {
    state.filters[field] = value;
  },
  changePage(state, page) {
    state.pagination.page = page;
  },
  selectAll(state, ids) {
    state.allSelected = true;
    ids.forEach(id => {
      if (state.selected.indexOf(id) == -1) {
        state.selected.push(id);
      }
    })
  },
  deselectAll(state) {
    state.allSelected = false;
    state.selected.splice(0, state.selected.length)
  },
  toggleSelected(state, id) {
    const index = state.selected.indexOf(id);

    if (index == -1) {
      state.selected.push(id);
    } else {
      state.selected.splice(index, 1);
      if (state.selected.length == 0) {
        state.allSelected = false;
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}